export default __webpack_public_path__ + "static/media/hz-beer.6eb629d0.jpg";